import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Typography, Tag, Button, Form, Input, message, Spin, Result } from 'antd';
import { getEquipoPublico, reportarFallaPublica } from 'api/publicEquipo';
import { apiAssetUrl } from 'utils/apiAssetUrl';

const { Title, Text, Paragraph } = Typography;

export default function EquipoPublicoPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getEquipoPublico(token)
      .then(setData)
      .catch((e) => {
        if (e?.response?.status === 404) setNotFound(true);
        else setError(true);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const onReport = async (values) => {
    setSending(true);
    try {
      await reportarFallaPublica(token, values);
      setSent(true);
      form.resetFields();
    } catch (e) {
      message.error(
        e?.response?.status === 429
          ? 'Demasiados reportes; intenta en unos minutos.'
          : 'No se pudo enviar el reporte.'
      );
    } finally {
      setSending(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 64 }}>
        <Spin />
      </div>
    );
  }

  if (notFound) {
    return (
      <Result status="404" title="Equipo no encontrado" subTitle="El código QR no es válido." />
    );
  }

  if (error || !data) {
    return (
      <Result
        status="error"
        title="No se pudo cargar el equipo"
        subTitle="Intenta nuevamente en unos minutos."
      />
    );
  }

  const { equipo, tenant } = data;
  return (
    <div style={{ maxWidth: 480, margin: '0 auto', padding: 16 }}>
      <Card>
        {tenant?.logo_url && (
          <img
            src={apiAssetUrl(tenant.logo_url)}
            alt={tenant.organization}
            style={{ height: 40, marginBottom: 12 }}
          />
        )}
        <Title level={4} style={{ marginTop: 0 }}>
          {equipo.nombre}
        </Title>
        <Paragraph>
          <Text type="secondary">Mantenido por {tenant?.organization}</Text>
        </Paragraph>
        <Tag color={equipo.estado === 'OPERATIVO' ? 'green' : 'orange'}>
          {equipo.estado || 'Sin estado'}
        </Tag>
      </Card>

      <Card title="Reportar un problema" style={{ marginTop: 16 }}>
        {sent ? (
          <Result
            status="success"
            title="¡Gracias!"
            subTitle="Tu reporte fue enviado a la empresa."
          />
        ) : (
          <Form form={form} layout="vertical" onFinish={onReport}>
            <Form.Item
              name="descripcion"
              label="¿Qué problema notaste?"
              rules={[{ required: true, message: 'Describe el problema' }, { max: 2000 }]}
            >
              <Input.TextArea rows={3} placeholder="Ej: la puerta no cierra bien" />
            </Form.Item>
            <Form.Item name="contacto_nombre" label="Tu nombre (opcional)">
              <Input />
            </Form.Item>
            <Form.Item name="contacto_fono" label="Teléfono (opcional)">
              <Input />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={sending} block>
              Enviar reporte
            </Button>
          </Form>
        )}
      </Card>
    </div>
  );
}
